const currencySymbols = [
    '\u0024',
    '\u20AC',
    '\u00A5',
    '\u00A3',
    '\u00A2',
    '\u20A0',
    '\u20A1',
    '\u20A2',
    '\u20A3',
    '\u20A4',
    '\u00A4',
    '\u20BF',
    '\u20A5',
    '\u20A6',
    '\u20A7',
    '\u20A8',
    '\u20A9',
    '\u20AA',
    '\u20AB',
    '\u20AD',
    '\u20AE',
    '\u20AF',
    '\u20B1',
    '\u20B2',
    '\u20B3',
    '\u20B4',
    '\u20B5',
    '\u20B8',
    '\u20B9',
    '\u20BA',
    '\u20BC',
    '\u20BD'
];
const textSymbols = [
    '\u2039',
    '\u203A',
    '\u00AB',
    '\u00BB',
    '\u0027',
    '\u2018',
    '\u201C',
    '\u201D',
    '\u201A',
    '\u201E',
    '\u00A1',
    '\u00BF',
    '\u2025',
    '\u2026',
    '\u01C2',
    '\u2030',
    '\u2031',
    '\u203C',
    '\u2049',
    '\u2048',
    '\u2047',
    '\u00A9',
    '\u00AE',
    '\u2122',
    '\u00A7',
    '\u00B6',
    '\u204B'
];
const mathematicalSymbols = [
    '\u003C',
    '\u003E',
    '\u2264',
    '\u2265',
    '\u2012',
    '\u2014',
    '\u00AF',
    '\u00B1',
    '\u00B0',
    '\u2212',
    '\u00B1',
    '\u00F7',
    '\u2044',
    '\u00D7',
    '\u0192',
    '\u222B',
    '\u2211',
    '\u221E',
    '\u221A',
    '\u007E',
    '\u2248',
    '\u2260',
    '\u220F',
    '\u00AC',
    '\u2205',
    '\u002A',
    '\u00BC',
    '\u00BD',
    '\u00BE'
];
const arrowSymbols = [
    '\u27F5',
    '\u27F6',
    '\u2191',
    '\u2193',
    '\u27F8',
    '\u27F9',
    '\u21E4',
    '\u21E5',
    '\u2913',
    '\u2195'
];
const latinSymbols = [
    '\u0100',
    '\u0101',
    '\u0102',
    '\u0103',
    '\u0104',
    '\u0105',
    '\u0106',
    '\u0107',
    '\u0108',
    '\u0109',
    '\u010A',
    '\u010B',
    '\u010C',
    '\u010D',
    '\u010E',
    '\u010F',
    '\u0189',
    '\u0111',
    '\u0112',
    '\u0113',
    '\u0114',
    '\u0115',
    '\u0116',
    '\u0117',
    '\u0228',
    '\u0119',
    '\u011A',
    '\u011B',
    '\u011C',
    '\u011D',
    '\u011E',
    '\u011F',
    '\u0120',
    '\u0121',
    '\u0124',
    '\u0125',
    '\u0126',
    '\u045B',
    '\u0128',
    '\u0129',
    '\u012A',
    '\u012B',
    '\u012C',
    '\u012D',
    '\u0130',
    '\u0131',
    '\u0133',
    '\u0134',
    '\u0135',
    '\u0136',
    '\u0137',
    '\u0139',
    '\u013A',
    '\u013B',
    '\u013C',
    '\u013D',
    '\u013E',
    '\u0141',
    '\u0142',
    '\u0143',
    '\u0144',
    '\u0145',
    '\u0146',
    '\u0147',
    '\u0148',
    '\u0149',
    '\u014A',
    '\u014B',
    '\u014C',
    '\u014D',
    '\u014E',
    '\u014F',
    '\u0150',
    '\u0151',
    '\u0152',
    '\u0153',
    '\u0154',
    '\u0155',
    '\u0156',
    '\u0157',
    '\u0158',
    '\u0159',
    '\u015A',
    '\u015B',
    '\u015E',
    '\u015F',
    '\u0160',
    '\u0161',
    '\u0162',
    '\u01AB',
    '\u0164',
    '\u0165',
    '\u0168',
    '\u0169',
    '\u016A',
    '\u016B',
    '\u016C',
    '\u016D',
    '\u016E',
    '\u016F',
    '\u0170',
    '\u0171',
    '\u0172',
    '\u0173',
    '\u0174',
    '\u0175',
    '\u0176',
    '\u0177',
    '\u0178',
    '\u0179',
    '\u017A',
    '\u017B',
    '\u017C',
    '\u017D'
];
export { arrowSymbols, currencySymbols, latinSymbols, mathematicalSymbols, textSymbols };
